import api from './api';
import {
  DataTable,
  TableColumn,
  TablePermission,
} from '../types/table.types';

export const TableService = {
  getAllTables: async (): Promise<DataTable[]> => {
    const response = await api.get<DataTable[]>('/tables');
    return response.data;
  },

  getTableById: async (id: string): Promise<DataTable> => {
    const response = await api.get<DataTable>(`/tables/${id}`);
    return response.data;
  },

  createTable: async (tableData: any): Promise<DataTable> => {
    const response = await api.post<DataTable>('/tables', tableData);
    return response.data;
  },

  updateTable: async (id: string, tableData: any): Promise<DataTable> => {
    const response = await api.put<DataTable>(`/tables/${id}`, tableData);
    return response.data;
  },

  deleteTable: async (id: string): Promise<void> => {
    await api.delete(`/tables/${id}`);
  },

  addColumn: async (tableId: string, columnData: any): Promise<TableColumn> => {
    const response = await api.post<TableColumn>(`/tables/${tableId}/columns`, columnData);
    return response.data;
  },

  updateColumn: async (tableId: string, columnId: string, columnData: any): Promise<TableColumn> => {
    const response = await api.put<TableColumn>(`/tables/${tableId}/columns/${columnId}`, columnData);
    return response.data;
  },

  deleteColumn: async (tableId: string, columnId: string): Promise<void> => {
    await api.delete(`/tables/${tableId}/columns/${columnId}`);
  },

  getTablePermissions: async (tableId: string): Promise<TablePermission[]> => {
    const response = await api.get<TablePermission[]>(`/tables/${tableId}/permissions`);
    return response.data;
  },

  setTablePermission: async (tableId: string, permissionData: any): Promise<TablePermission> => {
    const response = await api.post<TablePermission>(`/tables/${tableId}/permissions`, permissionData);
    return response.data;
  },

  removeTablePermission: async (tableId: string, permissionId: string): Promise<void> => {
    await api.delete(`/tables/${tableId}/permissions/${permissionId}`);
  },
};